import { ChangeDetectionStrategy, Component, Input } from '@angular/core'
import { CommonModule } from '@angular/common'
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner'
import { TranslateModule } from '@ngx-translate/core'
import { Observable, of } from 'rxjs'
import { GbDashboardSharedUiModule } from 'libs/gb-dashboard/shared/ui/src/lib/gb-dashboard-shared-ui.module'

@Component({
  selector: 'gb-presenter-save-status',
  imports: [CommonModule, MatProgressSpinnerModule, TranslateModule, GbDashboardSharedUiModule],
  templateUrl: './gb-presenter-save-status.component.html',
  styleUrl: './gb-presenter-save-status.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GbPresenterSaveStatusComponent {
  @Input() loaded$: Observable<boolean> = of(true)
}
